export default "__VITE_ASSET__fiAYz8ge__"